module.exports = __webpack_public_path__ + "static/media/logo-googleplus.f5e50927.svg";